import Origin from './Origin';

export default Origin;
